module.exports = __webpack_public_path__ + "img/益母草.0ef28fa5.jpg";